import React from "react";
import PropTypes from "prop-types";

import Icon from "../../Icon";
import styles from "./ModalHeader.module.scss";

const ModalHeader = ({ closeModal, children, hasCloseButton }) => {
  return (
    <div className={styles.modalHeader}>
      <span className={styles.modalTitle}>{children}</span>
      {hasCloseButton && (
        <button
          type="button"
          aria-label="Close Modal"
          aria-labelledby="close-modal"
          className={styles.modalClose}
          onClick={closeModal}
        >
          <Icon size={16} icon="close" />
        </button>
      )}
    </div>
  );
};

ModalHeader.propTypes = {
  closeModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  hasCloseButton: PropTypes.bool.isRequired
};

export default ModalHeader;
